import { AxiosError } from "axios";
import { createMutation } from "react-query-kit";

import { Refund } from "./GetRefund";
import { privateApi, ErrorResponse } from "api";

export type VoidRefundResult = Refund | null;
export type VoidRefundParams = {
    id: string;
    reason?: string | null;
};

async function voidRefund({ id, ...params }: VoidRefundParams): Promise<VoidRefundResult> {
    // ensure refund id was provided
    if (!id) {
        throw new TypeError('Id is a required parameter');
    }

    // make api call
    const result = await privateApi.patch<VoidRefundResult>(`${import.meta.env.VITE_API_BASE_URL}/finance/refunds/${id}/void`, params);

    // return the data object
    return result.data;
}

const useVoidRefund = createMutation<VoidRefundResult, VoidRefundParams, AxiosError<ErrorResponse>>({
    mutationFn: async (variables: VoidRefundParams) => voidRefund(variables),
});

export { voidRefund, useVoidRefund };
